import { Box, Container, Stack } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { generatePath, useNavigate } from "../../../../router-utils"
import { useXHR } from "@sembark-travel/xhr"
import {
	NewTataTeleIntegrationForm,
	type TIntegration,
} from "../../../../Integrations"

export default function NewTataTeleIntegrationPage() {
	const xhr = useXHR()
	const navigate = useNavigate()
	return (
		<>
			<Helmet>
				<title>New Tata Tele Integration</title>
			</Helmet>
			<Breadcrumbs
				title="New Integration"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					["", "Tata Tele Integration"],
				]}
			/>
			<Box paddingX="4" paddingY="8">
				<Box maxWidth="3xl" marginX="auto">
					<Box borderWidth="1" rounded="md" bgColor="default">
						<Container paddingY="6">
							<Stack gap="4">
								<NewTataTeleIntegrationForm
									initialValues={{
										name: "TataTele",
										description: "Inbound calls via Tata Tele Business",
									}}
									onSubmit={async (values) => {
										const integration = await xhr
											.post<{ data: TIntegration }>("integrations", {
												...values,
												platform: "tc_tatatele",
											})
											.then((resp) => resp.data.data)
										navigate("/integrations/:integrationId", {
											params: {
												integrationId: integration.uid,
											},
											replace: true,
										})
									}}
									onCancel={() => {
										navigate("/org/integrations", { replace: true })
									}}
								/>
							</Stack>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
